module.exports = __webpack_public_path__ + "static/img/thumb-03.21326c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/kerry/thumb/thumb-03.png
// module id = KbF3
// module chunks = 150